import { render, staticRenderFns } from "./DistributorSettingsTab.vue?vue&type=template&id=9dbb728e"
import script from "./DistributorSettingsTab.vue?vue&type=script&lang=js"
export * from "./DistributorSettingsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports